module.exports = __webpack_public_path__ + "static/media/Institito Mol - Vermelho.a55330df.svg";